import { ModuleWithProviders, NgModule } from '@angular/core';
import { MonitoringService } from './monitoring-service/monitoring.service';
import { AuthService } from './auth-service/auth.service';
import { MockPaymentSummaryService } from './payment-summary-service/mock.payment-summary.service';
import { SignalRService } from './signal-r-service/signal-r.service';
import { SharedService } from './shared-service/shared.service';
import { ModalService } from './modal-service/modal.service';
import { PaymentService } from './paymentService/payment.service';
import { DeviceService } from './device/device.service';
import { CookieService } from './cookieService/cookie.service';

/**
 * Provide singleton services that need to exist at the root level
 */
@NgModule()
export class ServicesModule {
  static forRoot(): ModuleWithProviders<ServicesModule> {
    return {
      ngModule: ServicesModule,
      providers: [
        MonitoringService,
        AuthService,
        MockPaymentSummaryService,
        SignalRService,
        SharedService,
        ModalService,
        PaymentService,
        DeviceService,
        CookieService,
      ],
    };
  }
}
